import { useQuery } from '@tanstack/react-query';
import { superAdminService } from '../services/super-admin.service';
import type { SuperAdmin } from '../types/super-admin.types';

export const SUPER_ADMINS_QUERY_KEY = ['super-admins'] as const;

export function useSuperAdmins(): {
  superAdmins: SuperAdmin[];
  hasData: boolean;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
} {
  const query = useQuery({
    queryKey: SUPER_ADMINS_QUERY_KEY,
    queryFn: () => superAdminService.listSuperAdmins(),
  });

  return {
    superAdmins: query.data ?? [],
    hasData: query.data !== undefined,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
